import { render } from "./ToastNotificationComponent.vue?vue&type=template&id=5c1d855f"
import script from "./ToastNotificationComponent.vue?vue&type=script&lang=js"
export * from "./ToastNotificationComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__